// W-0595 — GES > Relatórios > Negócios > Lista de Negócios — helpers de formatação/estado.
// Contratos snake_case dos DTOs reais (Setpar.Domain/Relatorios/RelNegocios/*.cs).
// IMPORTANTE: filtros são CUMULATIVOS (AND no WHERE), NÃO mutuamente exclusivos.

// Valor monetário #,##0.00 (pt-BR) — paridade FormatFloat do Delphi.
export const fmtMoeda = valor => {
  const numero =
    valor != null && !Number.isNaN(Number(valor)) ? Number(valor) : 0;
  return numero.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// Quantidade / cotação — 4 casas (paridade UQRRelNeg.pas "0.0000").
export const fmtDecimal4 = valor => {
  const numero =
    valor != null && !Number.isNaN(Number(valor)) ? Number(valor) : 0;
  return numero.toLocaleString('pt-BR', {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });
};

// data_negocio chega em ISO (yyyy-mm-ddThh:mm:ss). Formata conforme "Mostrar hora"
// (R8 — paridade UQRRelNeg.pas:103-105), sem aplicar timezone (corta a string).
export const fmtDataNegocio = (iso, mostrarHora) => {
  if (!iso) return '';
  const texto = String(iso);
  const partesData = texto.slice(0, 10).split('-');
  if (partesData.length !== 3) return texto;
  const data = `${partesData[2]}/${partesData[1]}/${partesData[0]}`;
  if (!mostrarHora) return data;
  const hora = texto.slice(11, 19);
  return hora ? `${data} ${hora}` : data;
};

// Extrai mensagem de erro do interceptor axios (que já faz unwrap para err.message).
export const mensagemErro = (err, fallback) =>
  err && err.message ? err.message : fallback || 'Erro inesperado';

// Converte "" / null / undefined em null; caso contrário Number. Campos numéricos opcionais.
export const toIntOuNull = v =>
  v === '' || v === null || v === undefined ? null : Number(v);

// Converte "" / null / undefined em null; caso contrário Number. Campos decimais opcionais.
export const toDecimalOuNull = v =>
  v === '' || v === null || v === undefined ? null : Number(v);

// Timestamp yyyyMMdd_HHmm para nome de arquivo exportado (paridade BotoesExport CentroCusto).
export const gerarTimestamp = () => {
  const now = new Date();
  const pad = n => String(n).padStart(2, '0');
  return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
    now.getDate()
  )}_${pad(now.getHours())}${pad(now.getMinutes())}`;
};

// Filtros default (espelha GerarRelNegociosRequest). filtroAtivo NÃO existe no backend:
// os 6 filtros são cumulativos (AND). Mantemos todos opcionais.
export const filtrosIniciais = () => ({
  codigo_grupo_empresa: null,
  codigo_conta: null,
  codigo_ativo_mercadoria: null,
  codigo_ativo_pagamento: null,
  codigo_usuario: null,
  data_ini: '',
  data_fim: '',
  val_ini: '',
  val_fim: '',
  observacao: '',
  mostrar_hora: false,
});

// Tamanho de página default (NormalizarPaginacao backend clampa em 1..200; default 20).
export const TAMANHO_PAGINA = 20;

// Monta o payload de filtro a partir do estado da UI (snake_case = contrato do backend).
// Reusado por /gerar e por /exportar-* (filtros idênticos — controller usa o mesmo request).
export const montarPayloadFiltro = filtros => ({
  codigo_grupo_empresa: toIntOuNull(filtros.codigo_grupo_empresa),
  codigo_conta: toIntOuNull(filtros.codigo_conta),
  codigo_ativo_mercadoria: toIntOuNull(filtros.codigo_ativo_mercadoria),
  codigo_ativo_pagamento: toIntOuNull(filtros.codigo_ativo_pagamento),
  codigo_usuario: toIntOuNull(filtros.codigo_usuario),
  data_ini: filtros.data_ini || null,
  data_fim: filtros.data_fim || null,
  val_ini: toDecimalOuNull(filtros.val_ini),
  val_fim: toDecimalOuNull(filtros.val_fim),
  observacao: filtros.observacao ? filtros.observacao.trim() : null,
  mostrar_hora: !!filtros.mostrar_hora,
});

// R2/R3/R4 — validações client espelham o Service.Validar (PRD §5.3). Retorna msg ou null.
export const validarFiltros = filtros => {
  if (!filtros.codigo_grupo_empresa) {
    return 'Grupo de empresa (GE) deve ser informado.';
  }

  const temDataIni = !!filtros.data_ini;
  const temDataFim = !!filtros.data_fim;
  // R3 — par de datas: ambas obrigatórias se uma informada.
  if (temDataIni !== temDataFim) {
    return 'Filtro Por Data selecionado, necessário informar data Inicial e data Final.';
  }
  if (temDataIni && temDataFim && filtros.data_ini > filtros.data_fim) {
    return 'Data Inicial não pode ser maior que a Data Final.';
  }

  // R4 — ValIni <= ValFim quando ambos informados.
  const valIni = toDecimalOuNull(filtros.val_ini);
  const valFim = toDecimalOuNull(filtros.val_fim);
  if (valIni !== null && valFim !== null && valIni > valFim) {
    return 'Valor Inicial > Valor Final';
  }

  // R2 — exigir >= 1 filtro além do GE (evita varredura total).
  const temFiltro =
    !!filtros.codigo_ativo_mercadoria ||
    !!filtros.codigo_ativo_pagamento ||
    temDataIni ||
    temDataFim ||
    valIni !== null ||
    valFim !== null ||
    !!filtros.codigo_conta ||
    (filtros.observacao && filtros.observacao.trim().length > 0) ||
    !!filtros.codigo_usuario;
  if (!temFiltro) {
    return 'Selecione ao menos um filtro para gerar o relatório.';
  }

  return null;
};
